import { render, staticRenderFns } from "./DeviceOTADeviceForm.vue?vue&type=template&id=d36c7fd6&scoped=true"
import script from "./DeviceOTADeviceForm.vue?vue&type=script&lang=ts"
export * from "./DeviceOTADeviceForm.vue?vue&type=script&lang=ts"
import style0 from "./DeviceOTADeviceForm.vue?vue&type=style&index=0&id=d36c7fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36c7fd6",
  null
  
)

export default component.exports